export default "__VITE_ASSET__CBH633Bl__"